// extracted by mini-css-extract-plugin
export default {"actions":"FlaggedUsersTable_actions_U8sgn","deletedUser":"FlaggedUsersTable_deletedUser_gNRFs"};